import { Injectable } from '@angular/core';
import { InvoiceAddress, InvoiceCustomer } from '../../domain/entities/invoice.entity';
import { InvoiceRevenueEditData, InvoiceRevenueEditRequest } from '../../domain/models/invoice-revenue-edit.model';
import { RevenueInvoiceEventDto, RevenueInvoiceEventUpdateDto, ViewAddressDto } from '../dtos/invoice.dto';

@Injectable()
export class InvoiceRevenueEditMapper {
  fromEventDto(dto: RevenueInvoiceEventDto): InvoiceRevenueEditData {
    const revenue = dto.revenue ?? {};
    const payer = revenue.payer ?? {};
    const address = this.pickAddress(revenue.address);

    return {
      invoiceId: dto.id,
      revenueId: dto.id,
      customer: {
        name: payer.name ?? '',
        taxId: payer.taxId ?? ''
      },
      address: {
        street: address.streetAddress ?? '',
        number: address.number ?? '',
        neighborhood: address.district ?? address.neighborhood ?? '',
        postalCode: address.postalCode ?? '',
        city: address.city ?? '',
        state: address.state ?? '',
        complement: address.address2 ?? '',
        email: address.email ?? ''
      }
    };
  }

  toUpdateDto(request: InvoiceRevenueEditRequest): RevenueInvoiceEventUpdateDto {
    const revenue: RevenueInvoiceEventUpdateDto['revenue'] = {};

    if (request.payer) {
      const payer: NonNullable<RevenueInvoiceEventUpdateDto['revenue']['payer']> = {};

      if (request.payer.name !== undefined) {
        payer.name = request.payer.name;
      }

      if (request.payer.taxId !== undefined) {
        payer.taxId = request.payer.taxId;
      }

      if (Object.keys(payer).length > 0) {
        revenue.payer = payer;
      }
    }

    if (request.address) {
      const address: NonNullable<RevenueInvoiceEventUpdateDto['revenue']['address']> = {};

      this.assignIfChanged(address, 'postalCode', request.address.postalCode);
      this.assignIfChanged(address, 'streetAddress', request.address.street);
      this.assignIfChanged(address, 'number', request.address.number !== undefined ? String(request.address.number) : undefined);
      this.assignIfChanged(address, 'district', request.address.neighborhood);
      this.assignIfChanged(address, 'address2', request.address.complement);
      this.assignIfChanged(address, 'state', request.address.state);
      this.assignIfChanged(address, 'city', request.address.city);
      this.assignIfChanged(address, 'email', request.address.email);

      if (Object.keys(address).length > 0) {
        revenue.address = address;
      }
    }

    return {
      id: request.revenueId,
      revenue
    };
  }

  private assignIfChanged<T extends Record<string, string>>(target: T, key: keyof T, value: string | undefined): void {
    if (value !== undefined) {
      target[key] = value as T[keyof T];
    }
  }

  private pickAddress(address?: ViewAddressDto | ViewAddressDto[]): ViewAddressDto {
    return Array.isArray(address) ? address[0] ?? {} : address ?? {};
  }
}
